export default [
  {
    path: "/login",
    name: "login",
    component: () => import("../views/account/login.vue"),
    meta: {
      title: "Login",
      guest: true,
    },
  },
  {
    path: "/forgot-password",
    name: "Forgot password",
    component: () => import("../views/account/forgot-password.vue"),
    meta: {
      title: "Forgot Password",
      guest: true,
    },
  },
  {
    path: "/reset-password",
    name: "Reset password",
    component: () => import("../views/account/reset-password.vue"),
    meta: {
      title: "Reset Password",
      guest: true,
    },
  },
  {
    path: "/logout",
    name: "logout",
    meta: {
      title: "Logout",
      authRequired: true,
    },
    component: () => import("../views/account/logout.vue")
  },
  // {
  //   path: "/dashboard",
  //   name: "dashboard",
  //   meta: {
  //     title: "Dashboard",
  //     authRequired: true,
  //   },
  //   component: () => import("../views/dashboard.vue"),
  // },
  {
    path: "/profile",
    name: "profile",
    meta: {
      title: "profile",
      authRequired: true,
    },
    component: () => import("../views/profile.vue"),
  },
  {
    path: "/admin",
    name: "admin-list",
    meta: {
      title: "List Admin",
      authRequired: true,
    },
    component: () => import("../views/admin/list-admin.vue"),
  },
  {
    path: "/admin/create",
    name: "admin-create",
    meta: {
      title: "Create Admin",
      authRequired: true,
    },
    component: () => import("../views/admin/create-admin.vue"),
  },
  {
    path: "/admin/edit/:id",
    name: "admin-edit",
    meta: {
      title: "Edit Admin",
      authRequired: true,
    },
    component: () => import("../views/admin/edit-admin.vue"),
  },
  {
    path: "/customer",
    name: "customer-list",
    meta: {
      title: "List Customer",
      authRequired: true,
    },
    component: () => import("../views/customer/list-customer.vue"),
  },
  {
    path: "/customer/:id",
    name: "customer-detail",
    meta: {
      title: "Detail Customer",
      authRequired: true,
    },
    component: () => import("../views/customer/detail-customer.vue"),
  },
  {
    path: "/company",
    name: "company-list",
    meta: {
      title: "List Company",
      authRequired: true,
    },
    component: () => import("../views/company/list-company.vue"),
  },
  {
    path: "/company/create",
    name: "company-create",
    meta: {
      title: "Create Company",
      authRequired: true,
    },
    component: () => import("../views/company/create-company.vue"),
  },
  {
    path: "/company/edit/:id",
    name: "company-edit",
    meta: {
      title: "Edit Company",
      authRequired: true,
    },
    component: () => import("../views/company/edit-company.vue"),
  },
  {
    path: "/company/:id",
    name: "company-detail",
    meta: {
      title: "Detail Company",
      authRequired: true,
    },
    component: () => import("../views/company/detail-company.vue"),
  },
  {
    path: "/driver",
    name: "driver-list",
    meta: {
      title: "List Driver",
      authRequired: true,
    },
    component: () => import("../views/driver/list-driver.vue"),
  },
  {
    path: "/driver/:id",
    name: "driver-detail",
    meta: {
      title: "Detail Driver",
      authRequired: true,
    },
    component: () => import("../views/driver/detail-driver.vue"),
  },
  {
    path: "/price",
    name: "price-list",
    meta: {
      title: "List Price",
      authRequired: true,
    },
    component: () => import("../views/price/list-price.vue"),
  },
  {
    path: "/order/:id",
    name: "order-detail",
    meta: {
      title: "Detail order",
      authRequired: true,
    },
    component: () => import("../views/order/detail-order.vue"),
  },
  {
    path: "/order",
    name: "order-list",
    meta: {
      title: "List Order",
      authRequired: true,
    },
    component: () => import("../views/order/list-order.vue"),
  },
  {
    path: "/price/create",
    name: "price-create",
    meta: {
      title: "Create Price",
      authRequired: true,
    },
    component: () => import("../views/price/create-price.vue"),
  },
  {
    path: "/price/edit/:id",
    name: "price-edit",
    meta: {
      title: "Edit Price",
      authRequired: true,
    },
    component: () => import("../views/price/edit-price.vue"),
  },

  {
    path: '/city',
    name: 'city-list',
    component: () => import('../views/city/list-city.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/city/create',
    name: 'city-create',
    component: () => import('../views/city/create-city.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/city/edit/:id',
    name: 'city-edit',
    component: () => import('../views/city/edit-city.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/city/detail/:id',
    name: 'city-detail',
    component: () => import('../views/city/detail-city.vue'),
    meta: { requiresAuth: true }
  },
  
  {
    path: '/404',
    name: 'NotFound',
    meta: {
      title: "Page Not Found",
      authRequired: true,
    },
    component: () => import("../views/404.vue"),
  },
  {
    path: '/:catchAll(.*)', redirect: '404'
  }
];